import { createFileRoute } from '@tanstack/react-router';
import { TradeInAppraisalPageWrapper } from '..';

export const Route = createFileRoute('/(authenticated)/trade/$shortId/$title/')(
  {
    component: TradeInAppraisalPageWrapper,
  },
);
